import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';
import { InlineWidget } from 'react-calendly';

const contactDetails = [
  { icon: Mail,   label: 'Email',    value: 'hello@smartsolution.ai', color: '#2563EB' },
  { icon: Phone,  label: 'Phone',    value: '+965 6596 6786',        color: '#3B82F6' },
  { icon: MapPin, label: 'Location', value: 'Kuwait City, Kuwait',   color: '#2563EB' },
];

export const ContactSection = () => {
  return (
    <section
      id="contact"
      className="section-padding bg-white relative overflow-hidden"
      data-testid="contact-section"
    >
      <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] rounded-full bg-[#2563EB]/4 blur-[110px] pointer-events-none" />

      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16">

          {/* Left info */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="section-label">Get in Touch</span>
              <span className="w-6 h-px bg-[#2563EB]/30" />
            </div>
            <h2
              className="font-display font-bold text-[#0F172A] mb-4"
              style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)' }}
            >
              Schedule a<br />
              <span className="italic text-gold">Meeting</span>
            </h2>
            <p className="text-[#374151] mb-10 leading-relaxed text-sm">
              Pick a time that works for you. We'll connect to discuss your project
              and map out the next steps together.
            </p>

            <div className="space-y-5">
              {contactDetails.map(({ icon: Icon, label, value, color }) => (
                <motion.div
                  key={label}
                  whileHover={{ x: 4 }}
                  className="flex items-center gap-4"
                >
                  <div
                    className="w-9 h-9 flex items-center justify-center shrink-0 border border-[#E2E8F0]"
                    style={{ backgroundColor: `${color}10` }}
                  >
                    <Icon size={15} style={{ color }} />
                  </div>
                  <div>
                    <div className="font-mono text-[0.55rem] tracking-widest text-[#374151] mb-0.5 uppercase">{label}</div>
                    <div className="text-[#0F172A] text-sm font-medium">{value}</div>
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="divider-gold mt-10 opacity-60" />
          </motion.div>

          {/* Right Calendly */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="lg:col-span-3"
          >
            <div className="border border-[#E2E8F0] overflow-hidden shadow-sm">
              <InlineWidget
                url="https://calendly.com/hello-smartsolution/30min"
                styles={{ height: '700px' }}
                pageSettings={{
                  backgroundColor: 'FFFFFF',
                  primaryColor: '153243',
                  textColor: '1A1A2E',
                  hideEventTypeDetails: false,
                  hideLandingPageDetails: false,
                }}
              />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};
